export default "__VITE_ASSET__BEccg0RZ__"